import {emptyArray} from '@packages/utilities/fp/utils';
import {type Type, Types} from '@packages/systems/wfdl';
import type {TranslatedNodeData} from '@packages/systems/localization-types';
import {collectChildrenAndNode} from './collectChildrenAndNode';

export function convertComponentPropertyDefaultToTranslatePayload(
  fieldId: string,
  translatableParentId: string,
  type: Type
): TranslatedNodeData[] {
  const defaultValue = Types.getDefaultValue(type, undefined);

  if (!defaultValue) {
    return emptyArray;
  }

  const result: TranslatedNodeData[] = [];

  if (typeof defaultValue === 'string' && Types.isAltTextType(type)) {
    if (
      defaultValue &&
      // Skip reserved alt text values
      !['__wf_reserved_inherit', '__wf_reserved_decorative'].includes(
        defaultValue
      )
    ) {
      result.push({
        _id: '', // this is not used for attribute prop defaults
        type: 'component-property',
        v: defaultValue,
        text: true,
        fieldId,
        translatableParentId,
      });
    }
    return result;
  } else if (Array.isArray(defaultValue) && Types.isListOfElements(type)) {
    for (const nodePojo of defaultValue) {
      for (const node of collectChildrenAndNode(nodePojo)) {
        if (!node.text) continue;

        result.push({
          _id: node.id,
          type: 'component-property',
          v: String(node.data?.value ?? ''),
          text: true,
          fieldId,
          translatableParentId,
        });
      }
    }
  } else {
    return emptyArray;
  }

  return result;
}
